import { useMemo } from 'react'
import { useGetBrands } from 'services/brandsApi'

export interface BrandOption {
  label: string
  value: number
}

/**
 * Shared hook for fetching brand options formatted for dropdowns/comboboxes.
 * Centralizes the fetch + map pattern used across brand selectors, filters, and bulk actions.
 */
export function useBrandOptions(enabled: boolean = true) {
  const { data: brandsData, isLoading } = useGetBrands({
    page: 1,
    page_size: 1000,
    ordering: 'name',
    enabled,
  })

  const brandOptions = useMemo<BrandOption[]>(() => {
    if (!brandsData?.results) return []
    return brandsData.results.map((brand) => ({
      label: brand.name,
      value: brand.id,
    }))
  }, [brandsData])

  return { brandOptions, isLoading }
}
